module.exports = ":host {\n    display: block;\n}\n:host .search .input-group-btn button {\n    margin: 0px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/search-input/search-input.component.css
// module id = ./src/app/shared/search-input/search-input.component.css
// module chunks = main